<div [@routerTransition]>
    <sub-header
        [title]="('Customers' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"
    ></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <tabset>
                    <tab heading="{{ 'BasicInformation' | localize }}">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Customer_CustomerCode">{{ l('CustomerCode') }} *</label>
                                    <input
                                        type="text"
                                        #Customer_CustomerCode="ngModel"
                                        id="Customer_CustomerCode"
                                        class="form-control"
                                        [(ngModel)]="customer.customerCode"
                                        name="CustomerCode"
                                        minlength="0"
                                        maxlength="30"
                                        required
                                    />
                                    <validation-messages [formCtrl]="Customer_CustomerCode"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Customer_Name">{{ l('Name') }} *</label>
                                    <input
                                        type="text"
                                        #Customer_Name="ngModel"
                                        id="Customer_Name"
                                        class="form-control"
                                        [(ngModel)]="customer.name"
                                        name="Name"
                                        required
                                    />
                                    <validation-messages [formCtrl]="Customer_Name"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Customer_Email">{{ l('Email') }}</label>
                                    <input
                                        type="text"
                                        #Customer_Email="ngModel"
                                        id="Customer_Email"
                                        class="form-control"
                                        [(ngModel)]="customer.email"
                                        name="Email"
                                    />
                                    <validation-messages [formCtrl]="Customer_Email"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="my-3">
                                    <label class="form-label" for="Customer_SalesLimit">{{ l('SalesLimit') }}</label>
                                    <input
                                        type="number"
                                        #Customer_SalesLimit="ngModel"
                                        id="Customer_SalesLimit"
                                        class="form-control"
                                        [(ngModel)]="customer.salesLimit"
                                        name="SalesLimit"
                                    />
                                    <validation-messages [formCtrl]="Customer_SalesLimit"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_Attention">{{ l('Attention') }}</label>
                                    <input
                                        type="text"
                                        #Customer_Attention="ngModel"
                                        id="Customer_Attention"
                                        class="form-control"
                                        [(ngModel)]="customer.attention"
                                        name="Attention"
                                        minlength="0"
                                        maxlength="30"
                                    />
                                    <validation-messages [formCtrl]="Customer_Attention"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_AttentionPhoneNo">{{ l('AttentionPhoneNo') }}</label>
                                    <input
                                        type="text"
                                        #Customer_AttentionPhoneNo="ngModel"
                                        id="Customer_AttentionPhoneNo"
                                        class="form-control"
                                        [(ngModel)]="customer.attentionPhoneNo"
                                        name="AttentionPhoneNo"
                                        minlength="0"
                                        maxlength="30"
                                    />
                                    <validation-messages [formCtrl]="Customer_AttentionPhoneNo"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_TaxRegistrationNo">{{ l('TaxRegistrationNo') }}</label>
                                    <input
                                        type="text"
                                        #Customer_TaxRegistrationNo="ngModel"
                                        id="Customer_TaxRegistrationNo"
                                        class="form-control"
                                        [(ngModel)]="customer.taxRegistrationNo"
                                        name="TaxRegistrationNo"
                                    />
                                    <validation-messages [formCtrl]="Customer_TaxRegistrationNo"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <br />
                                <br />
                                <label class="form-check form-check-custom form-check-solid">
                                    <input
                                        id="Customer_IsTaxExempt"
                                        #Customer_IsTaxExempt="ngModel"
                                        name="IsTaxExempt"
                                        [(ngModel)]="customer.isTaxExempt"
                                        type="checkbox"
                                        class="form-check-input"
                                    />
                                    <span class="form-check-label">
                                        {{ l('IsTaxExempt') }}
                                    </span>
                                </label>
                                <validation-messages [formCtrl]="Customer_IsTaxExempt"></validation-messages>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Customer_Remarks">{{ l('Remarks') }}</label>
                                    <input
                                        type="text"
                                        #Customer_Remarks="ngModel"
                                        id="Customer_Remarks"
                                        class="form-control"
                                        [(ngModel)]="customer.remarks"
                                        name="Remarks"
                                    />
                                    <validation-messages [formCtrl]="Customer_Remarks"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label for="PaymentTermName">{{ l('PaymentTerm') }}</label>
                                    <select
                                        name="customer.paymentTermId"
                                        [(ngModel)]="customer.paymentTermId"
                                        class="form-select"
                                    >
                                        <option value="">{{ l('SelectAPaymentTerm') }}</option>

                                        <option *ngFor="let item of allPaymentTerms" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label for="PriceGroupName">{{ l('PriceGroup') }}</label>
                                    <select
                                        name="customer.priceGroupId"
                                        [(ngModel)]="customer.priceGroupId"
                                        class="form-select"
                                    >
                                        <option value="">{{ l('SelectAPriceGroup') }}</option>

                                        <option *ngFor="let item of allPriceGroups" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label for="LocationName">{{ l('Location') }}</label>
                                    <select
                                        name="customer.locationId"
                                        [(ngModel)]="customer.locationId"
                                        class="form-select"
                                    >
                                        <option value="">{{ l('SelectALocation') }}</option>

                                        <option *ngFor="let item of allLocations" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label for="CurrencyName">{{ l('Currency') }}</label>
                                    <select
                                        name="customer.currencyId"
                                        [(ngModel)]="customer.currencyId"
                                        class="form-select"
                                    >
                                        <option value="">{{ l('SelectACurrency') }}</option>

                                        <option *ngFor="let item of allCurrencys" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'Address' | localize }}">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_Address1">{{ l('Address1') }}</label>
                                    <input
                                        type="text"
                                        #Customer_Address1="ngModel"
                                        id="Customer_Address1"
                                        class="form-control"
                                        [(ngModel)]="customer.address1"
                                        name="Address1"
                                    />
                                    <validation-messages [formCtrl]="Customer_Address1"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_Address2">{{ l('Address2') }}</label>
                                    <input
                                        type="text"
                                        #Customer_Address2="ngModel"
                                        id="Customer_Address2"
                                        class="form-control"
                                        [(ngModel)]="customer.address2"
                                        name="Address2"
                                    />
                                    <validation-messages [formCtrl]="Customer_Address2"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_Address3">{{ l('Address3') }}</label>
                                    <input
                                        type="text"
                                        #Customer_Address3="ngModel"
                                        id="Customer_Address3"
                                        class="form-control"
                                        [(ngModel)]="customer.address3"
                                        name="Address3"
                                    />
                                    <validation-messages [formCtrl]="Customer_Address3"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_City">{{ l('City') }}</label>
                                    <input
                                        type="text"
                                        #Customer_City="ngModel"
                                        id="Customer_City"
                                        class="form-control"
                                        [(ngModel)]="customer.city"
                                        name="City"
                                    />
                                    <validation-messages [formCtrl]="Customer_City"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_State">{{ l('State') }}</label>
                                    <input
                                        type="text"
                                        #Customer_State="ngModel"
                                        id="Customer_State"
                                        class="form-control"
                                        [(ngModel)]="customer.state"
                                        name="State"
                                    />
                                    <validation-messages [formCtrl]="Customer_State"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_Country">{{ l('Country') }}</label>
                                    <input
                                        type="text"
                                        #Customer_Country="ngModel"
                                        id="Customer_Country"
                                        class="form-control"
                                        [(ngModel)]="customer.country"
                                        name="Country"
                                    />
                                    <validation-messages [formCtrl]="Customer_Country"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_PostalCode">{{ l('PostalCode') }}</label>
                                    <input
                                        type="text"
                                        #Customer_PostalCode="ngModel"
                                        id="Customer_PostalCode"
                                        class="form-control"
                                        [(ngModel)]="customer.postalCode"
                                        name="PostalCode"
                                    />
                                    <validation-messages [formCtrl]="Customer_PostalCode"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_CountryCode">{{ l('CountryCode') }}</label>
                                    <input
                                        type="text"
                                        #Customer_CountryCode="ngModel"
                                        id="Customer_CountryCode"
                                        class="form-control"
                                        [(ngModel)]="customer.countryCode"
                                        name="CountryCode"
                                    />
                                    <validation-messages [formCtrl]="Customer_CountryCode"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Customer_PhoneNo">{{ l('PhoneNo') }}</label>
                                    <input
                                        type="text"
                                        #Customer_PhoneNo="ngModel"
                                        id="Customer_PhoneNo"
                                        class="form-control"
                                        [(ngModel)]="customer.phoneNo"
                                        name="PhoneNo"
                                    />
                                    <validation-messages [formCtrl]="Customer_PhoneNo"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabset>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button
                        (click)="save()"
                        class="btn btn-primary blue me-2"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>

                    <button
                        *ngIf="!this.customer.id"
                        (click)="saveAndNew()"
                        class="btn btn-primary blue float-right"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAndNew') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
